import React , { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router  } from 'react-router-dom';

import './index.css';
import App from './App';
import 'normalize.css';
import "@fontsource/almarai";
import "@fontsource/inter"; 
import './i18n';
import reportWebVitals from './reportWebVitals';
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const LoadingSpinner = () => (
  <div className='fixed inset-0 w-full h-screen flex justify-center items-center bg-white z-[99999]'>
    <AiOutlineLoading3Quarters className='animate-spin text-6xl text-primary'/>
  </div>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <Suspense fallback={<LoadingSpinner />}>
        <Router>
            <App />
        </Router>
      </Suspense>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
